import { h, JSX } from 'preact'
import { decode } from '@utils/dom'

export default function Breadcrumbs({ homeTitle = '', activeName = '', breadcrumbs = [] }) {
	return (
		<div className="breadcrumb">
			<ul className="breadcrumb-list">
				{!!homeTitle && (
					<li key={homeTitle} className="breadcrumb-item">
						<a href="/" className="breadcrumb-item-name">
							{decode(homeTitle)}
						</a>
					</li>
				)}

				{breadcrumbs.length > 0 &&
					breadcrumbs.map(({ id, seName, name }) => {
						const shouldShow = name !== activeName

						return (
							shouldShow && (
								<li key={id} className="breadcrumb-item">
									<a href={seName} className="breadcrumb-item-name">
										{decode(name)}
									</a>
								</li>
							)
						)
					})}

				{!!activeName && (
					<li key={activeName} className="breadcrumb-item --active-item">
						<strong className="breadcrumb-item-name --active-item">{decode(activeName)}</strong>
					</li>
				)}
			</ul>
		</div>
	)
}
